export default __webpack_public_path__ + "static/media/jackpotslot.a8750f68.png";